//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { StudentPortalCalendarSettings } from './StudentPortalCalendarSettings';
import { PortalSettingsDisplayItem } from './PortalSettingsDisplayItem';
import { AttendanceStatus, StudentPortalHomepage } from './Enums';

export class StudentPortalSettingsDisplayItem extends PortalSettingsDisplayItem {
    AccountBalanceDate: string = "1970-01-01T00:00:00";
    AllowPartialOnlinePayments: boolean = false;
    AllowProfileEditing: boolean = false;
    CanSetTimeZone: boolean = false;
    CancellationPolicyText: string | null = null;
    HoursUntilDeadline: number = 0;
    AfterEventCancellationDeadlineStatus: AttendanceStatus = AttendanceStatus.Unrecorded;
    BeforeEventCancellationDeadlineStatus: AttendanceStatus = AttendanceStatus.Unrecorded;
    AllowStudentPortalEventSignup: boolean = false;
    AllowOnlineCancellation: boolean = false;
    StudentPortalSignupMakeupRequired: boolean = false;
    CalendarSettings: StudentPortalCalendarSettings | null = null;
    ForceAutoPay: boolean = false;
    CurrencyCode: string | null = null;
    HasEventCategoryWithEmailReminders: boolean = false;
    HasEventCategoryWithSMSReminders: boolean = false;
    InitialView: StudentPortalHomepage = StudentPortalHomepage.Calendar;
    InvoiceTaxInclusive: boolean = false;
    Locale: string | null = null;
    NewsPostsPerPage: number = 0;
    PaymentSourceRequired: boolean = false;
    SchoolWebsiteUrl: string | null = null;
    ShowAccountAndInvoices: boolean = false;
    ShowMakeupCredits: boolean = false;
    ShowRepertoire: boolean = false;
    ShowSchoolNews: boolean = false;
    ShowStudentContactList: boolean = false;
    ShowTeacherAddress: boolean = false;
    ShowTeacherEmailAndTelephoneNumber: boolean = false;
    TimeZoneID: string | null = null;
    CurrentUTCOffsetMinutes: number = 0;
    SchoolAddress: string | null = null;
    SchoolTelephone: string | null = null;
    SchoolEmail: string | null = null;
    SchoolSubscribed: boolean = false;
    SchoolTrialEndDate: string = "1970-01-01T00:00:00";
    AdvanceBookingLimitDays: number = 0;
    LogoUrl: string | null = null;
    PackagesActive: boolean = false;
    GoogleReviewsLink: string | null = null;

    constructor(initializer?: Partial<StudentPortalSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentPortalSettingsDisplayItem";
}
